import React, { useEffect, useCallback, useRef, useContext } from "react";
import { Popover, message, Tooltip } from "antd";
import qs from "query-string";
import { useHistory, Link } from "react-router-dom";
import Icon from "../../Icon";
import { lang } from "../../context";
import "./index.less";
import events from "../../context/events";
import { connect } from "dvajs";
import { JoyspaceState, FolderInfoRes } from "@/models/joyspace";
import {
  folderType,
  joyspacePermissionType,
  getJoySpaceReadOnlyPermission,
  folderTypeEnum,
  getJoySpaceReadWritePermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadFolderPermission
} from "../../config/permissions.config";
import Api from "../../api";
import openFolderModal from "../../contextModal/FolderModal";
import GlobalContext from "@/context/GlobalContext";
import { PermissionEnum } from "../../permissions";
import { OpenFolderStatus } from "../../types";
import { Order, Sort } from "../List/Filters/config";
import ShareIcon from "../List/ShareIcon";
import { useNavigator } from "@/utils/NetworkCheck";
export interface IProps {
  name: "root" | "teamRoot";
  currentRouterInfo: any;
  folderInfoMap: any;
  getCurrentRouterInfo: Function;
  changeFolderInfoById: Function;
}

interface IPath {
  id: string;
  name: string;
  url?: string;
  description?: string;
  permissionsType?: number; // (权限类型. 1-读写 2-只读)
  isRoot?: boolean; // (是否是根级目录)
  isLast?: boolean; // (是否是末级导航)
  isShared: boolean; // 是否分享过文件夹
  permissions: any[];
}

interface Parames {
  fullName: string;
  fullPath: string;
  permissionsType?: number;
  description?: string;
}
function SpaceCategoriesPaths(props: IProps) {
  const {
    name,
    currentRouterInfo,
    getCurrentRouterInfo,
    folderInfoMap,
    changeFolderInfoById
  } = props;
  const { listen, location } = useHistory();
  const [paths, setPaths] = React.useState<IPath[]>([]);
  const [collapseNavList, setCollapseNav] = React.useState<IPath[]>([]);
  const [disabled, setDisabled] = React.useState(false);
  const { authInfo, onLine } = useContext(GlobalContext);
  const userId = authInfo.userId;
  React.useMemo(() => {
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  // const teamId = authInfo?.teamUserInfo?.userId;
  // 获取根级导航标题 // 我的文件或者共享文件
  const langTitleFn = function (type: string) {
    switch (type) {
      case folderType.MY:
        return lang("c.SpaceCategoriesPaths.myDocumentsTitle");
      case folderType.SHARE:
        return lang("c.SpaceCategoriesPaths.shareDocumentsTitle");
      default:
        return "";
    }
  };

  // 清除router CreatRouterParames
  const onCreatRouterParames = useCallback(
    (id: string) => {
      let list: any = [...paths];
      list.splice(1, 0, [...collapseNavList]);
      let nav = list.flat(); // 拉平数组
      const index = nav.findIndex((item: IPath) => item.id === id);
      if (index !== -1 && index !== nav.length - 1) {
        nav.splice(index + 1, nav.length); // 删除不包含本身的数据的之后的数据
      }
      nav[nav.length - 1].isRoot = nav.length === 2 ? true : false;
      nav[nav.length - 1].isLast = true;
      setCollapseNav(handleCollapseNav(nav));
      setPaths(nav);
    },
    [paths, collapseNavList]
  );
  // 生成router
  const onCreatRouter = useCallback(
    (rootNode: any, parames: FolderInfoRes, folderInfoMap: any) => {
      const {
        full_name: fullName = "",
        full_path: fullPath = "",
        permissions,
        description = "",
        created_by = ""
      } = parames || {};
      let pathList: IPath[] = [rootNode];
      if (pathList[0].isLast) {
        setPaths(pathList);
        events.emit("onShowFolderDesc", "");
        return;
      }
      const navNameList1 = fullName.split("$@$");
      const navPathList = fullPath.split("$@$");
      const navNameList = navPathList.map((id, index) => {
        return folderInfoMap[id]?.name || navNameList1[index] || "";
      });
      const navList: IPath[] = navPathList.map((id, index) => {
        const info = folderInfoMap[id];
        return {
          id,
          name: navNameList[index] || "",
          url: `${location.pathname}?${qs.stringify({ categoryId: id })}`,
          description,
          permissionsType:
            currentRouterInfo.type === folderTypeEnum.MY
              ? getJoySpaceReadAllPermission()
              : getJoySpaceReadFolderPermission(permissions),
          createdId: created_by,
          isRoot: index ? false : true,
          isLast: index === navPathList.length - 1,
          isShared: info?.isShared,
          permissions: permissions,
          type: currentRouterInfo.type
        };
      });
      events.emit("onShowFolderDesc", navList[navList.length - 1].description);
      const listAll = pathList.concat(navList);
      setCollapseNav(handleCollapseNav(listAll));
      console.log(listAll, "listAlllistAlllistAlllistAlllistAll");
      setPaths(listAll);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname, folderInfoMap, currentRouterInfo]
  );
  const getRootFolder = (folderInfoMap: any, currentRouterInfo: any) => {
    // eslint-disable-next-line no-debugger
    // debugger;
    if (currentRouterInfo.type === folderTypeEnum.MY || currentRouterInfo?.id === folderType.MY) {
      return {
        ...folderInfoMap.myspace,
        url: folderInfoMap.myspace.to,
        name: langTitleFn(folderType.MY),
        isLast: currentRouterInfo?.id === folderType.MY
        // isShared: (folderInfoMap[currentRouterInfo?.id] || {}).isShared || false,
      };
    } else if (
      currentRouterInfo.type === folderTypeEnum.SHARE ||
      currentRouterInfo?.id === folderType.SHARE
    ) {
      return {
        ...folderInfoMap[folderType.SHARE],
        url: folderInfoMap[folderType.SHARE].to,
        name: langTitleFn(folderType.SHARE),
        isLast: currentRouterInfo?.id === folderType.SHARE
        // isShared: (folderInfoMap[currentRouterInfo?.id] || {}).isShared || false,
      };
    } else {
      console.warn("getRootFolder出错");
    }
  };
  // 设置文件标题回调
  const setFolderTitle = (parames: any) => {
    const { name, desc, onClose } = parames;
    Api.categories
      .setFolderApi(paths[paths.length - 1].id, name, desc)
      .then((res) => {
        if (res?.data) {
          message.success("设置成功", 2);
          changeFolderInfoById({
            id: paths[paths.length - 1].id,
            name,
            desc
          });
          onClose?.();
        } else {
          // console.log(res, 'resresresresresres==>');
          message.error(res?.status || "无权限操作");
        }
      })
      .catch((err) => {
        message.error(err);
        // setLoading(false);
      });
  };
  const initNav = useRef<string>();
  // 获取导航
  useEffect(() => {
    getCurrentRouterInfo().then((useRouterInfo: any) => {
      const rootNode = getRootFolder(folderInfoMap, useRouterInfo);
      onCreatRouter(rootNode, useRouterInfo, folderInfoMap);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRouterInfo]);
  // 导航折叠
  const handleCollapseNav = function (list: IPath[]) {
    if (list.length > 4) {
      return list.splice(1, list.length - 3);
    }
    return [];
  };
  // 渲染折叠导航DOM
  const handleRenderCollapseNav = useCallback(() => {
    const content = (
      <div className="joyspace-collapse-nav">
        {collapseNavList.map((path: IPath) => {
          return (
            <Link
              key={path?.id}
              to={path?.url as string}
              onClick={() => {
                events.emit("onShowFolderDesc", path.description);
                // onCreatRouterParames(path?.id);
              }}
            >
              <ShareIcon isShared={path.isShared} />
              {/* <Icon
                                className="joyspace-collapse-nav_file_icon"
                                type="iconapp_btn_file_4"
                            /> */}
              <span className="joyspace-collapse-nav_text joyspace-breadcrumb-ellipsis">
                {path.name}
              </span>
            </Link>
          );
        })}
      </div>
    );
    return (
      <Popover
        overlayClassName="joyspace-collapse-nav_popover"
        content={content}
        title={null}
        trigger="hover"
      >
        <span style={{ color: "#999999", cursor: "pointer" }}>...</span>
      </Popover>
    );
  }, [collapseNavList]);
  // 渲染主体
  if (paths.length === 1) {
    return (
      <div className="joyspace-breadcrumb-container">
        <div className="joyspace-breadcrumb">{paths[0].name}</div>
      </div>
    );
  }
  return paths.length ? (
    <div className="joyspace-breadcrumb-container">
      {/* 导航 */}
      <div className="joyspace-breadcrumb">
        {paths.map((path, index) => {
          return (
            <React.Fragment key={path.id}>
              {/* 箭头 */}
              {index !== 0 && (
                <Icon
                  className={
                    path.isLast ? "breadcrumb-icon breadcrumb-last-nav" : "breadcrumb-icon"
                  }
                  type="iconwin_right"
                />
              )}
              {/* 折叠的导航 */}
              {index === 1 && collapseNavList.length !== 0 && handleRenderCollapseNav()}
              {index === 1 && collapseNavList.length !== 0 && (
                <Icon
                  className={
                    path.isLast ? "breadcrumb-icon breadcrumb-last-nav" : "breadcrumb-icon"
                  }
                  type="iconwin_right"
                />
              )}
              {/* 末级及次级导航 */}
              <Link
                className={
                  path.isLast
                    ? "breadcrumb-link breadcrumb-last-nav joyspace-breadcrumb-ellipsis2"
                    : "breadcrumb-link  joyspace-breadcrumb-ellipsis"
                }
                style={{ overflow: path.isRoot ? "hidden" : "" }}
                title={path.name}
                to={path?.url as string}
                onClick={() => {
                  onCreatRouterParames(path.id);
                  events.emit("onShowFolderDesc", path.description);
                }}
              >
                {path.name}
              </Link>
            </React.Fragment>
          );
        })}
        {/*
                设置入口：
                1、文件列表-更多-设置；2、导航标题后方编辑按钮，点击后弹出设置弹窗。
                第一级文件夹可编辑内容：名称、描述、管理协作者。
                子文件夹可编辑内容只有名称，没有描述和协作者。
                一级文件夹可以编辑
                权限规则如下：
                    文件夹的编辑/设置权限 与协作者权限关联。
                    协作者权限为可编辑时，可修改文件夹名称、描述。
                    协作者权限为仅查看时，只可查看文件夹详情，不可修改。
                */}
        {/* {paths[1]?.isRoot && paths[1]?.permissionType === permissionFileType.readWrite && (
                    <div className="joyspace-breadcrumb-title-edit">
                        <Icon type="iconic_editor" />
                    </div>
                )} */}
        {paths[paths.length - 1]?.isRoot &&
          paths[paths.length - 1]?.permissions?.includes(PermissionEnum.FOLDER_EDIT) &&
          getJoySpaceReadOnlyPermission() && (
            <Tooltip placement="top" title="设置文件夹名称和描述">
              <div
                className={
                  disabled
                    ? "joyspace-breadcrumb-title-edit joyspace-breadcrumb-title-edit_icon"
                    : "joyspace-breadcrumb-title-edit"
                }
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  const item: any = paths[paths.length - 1] || {};
                  openFolderModal({
                    id: paths[paths.length - 1].id,
                    isModalVisible: true,
                    title: "设置文件夹",
                    name: item.name,
                    description: item.description,
                    permissionsType: item.permissionsType,
                    isRoot: true,
                    folderType: currentRouterInfo.type,
                    permissions: item.permissions,
                    isOpenFolder: item.open === 2 ? OpenFolderStatus.OPEN : OpenFolderStatus.CLOSE,

                    disabled:
                      item.type === folderTypeEnum.SHARE &&
                      !item.permissions.includes(PermissionEnum.SHARE_MANAGE),
                    onOk: setFolderTitle
                  });
                  events.emit("onShowFolderDesc", item.description);
                }}
              >
                <Icon type="iconic_editor" />
              </div>
            </Tooltip>
          )}
      </div>
      {/* 一级文件夹描述 tips: 我的文件不算 */}
      {/* {paths[paths.length - 1]?.isRoot && paths[paths.length - 1]?.description && (
                <div className="joyspace-breadcrumb-file-desc">
                    {paths[paths.length - 1]?.description || ''}
                </div>
            )} */}
    </div>
  ) : null;
}
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    currentRouterInfo: joyspace.currentRouterInfo,
    folderInfoMap: joyspace.folderInfoMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getCurrentRouterInfo() {
      return dispatch({ type: "joyspace/getCurrentRouterInfo", payload: {} });
    },
    changeFolderInfoById(data: any) {
      return dispatch({ type: "joyspace/changeFolderInfoById", payload: { ...data } });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SpaceCategoriesPaths);
